import { Button, Row, Col, Typography,Input,Spin } from "antd";
import { useState } from "react";
import { TextSqlHeader } from "./textSqlHeader";
import { TextSqlHomePage } from "./textSqlHomepage";
import { ChatWindow } from "../chatwindow";
import { ChatModelFetch} from "../../../shared/axios";
import Lottie from "react-lottie";
import ResponseJson from "../../../assets/json/generating response animation.json";
import { v4 as uuid } from "uuid";
// import "./textSql.css";
import { ArrowRightOutlined } from '@ant-design/icons';
import { toast } from "react-toastify";
import {LoginWrapper} from "../LoginWrapper/login";

const { Text } = Typography;
const { TextArea } = Input;

const TextSqlBotComponent = () => {
  const [isChatting, setIsChatting] = useState(false);
  const [inputQuestion, setInputQuestion] = useState("");
  const [messages, setMessage] = useState([]);
  const [isTypingStopped, setIsTypingStopped] = useState(false);
  const [selectedCardMessage, setSelectedCardMessage] = useState("");
  const [selectedCardName, setSelectedCardName] = useState("");

  const handleCardSelect = (cardName) => {
    setSelectedCardName(cardName);
    setSelectedCardMessage(`Thanks for selecting ${cardName}. Now enter the query in the box below.`);
  };
  
  const handleCopy = (code) => {
    navigator.clipboard.writeText(code).then(
      () => {
        toast.success("Code copied to clipboard!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      },
      (err) => {
        toast.error("Failed to copy code. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      }
    );
  };
  

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: ResponseJson,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };  

  const handleTypingStopped = () => {
    setIsTypingStopped(true);
    // Set the bot response
    setMessage((pv) => {
      const newFields = [...pv];
      if (
        newFields.length !== 0 &&
        typeof newFields[newFields.length - 1]["content"] == "object"
      ) {
        newFields[newFields.length - 1] = {
          ...newFields[newFields.length - 1],
          content: "The Response Has Been Canceled By User.",
        };
      }

      return newFields;
    });
  };
  // Accpets the feedback and enables the input field
  const handleFeedback = (value, botID) => {
    const updatedData = messages.map((item) => {
      if (item?.bot_id === botID) {
        return {
          ...item,
          feedbackAccepted: [...item["feedbackAccepted"], value],
        }; // Only update matching item
      }
      return item;
    });
    setMessage(updatedData);
  };

  // Accpets the typing completed value
  const handleTypingCompleted = (value) => {
    setMessage((pv) => {
      const newFields = [...pv];

      if (
        newFields.length !== 0 &&
        newFields[newFields.length - 1]["typingCompleted"] == null
      ) {
        newFields[newFields.length - 1] = {
          ...newFields[newFields.length - 1],
          typingCompleted: value,
        };
      }
      return newFields;
    });
    setIsTypingStopped(false);
  };


  const handleQuestionSubmitted = async (question) => {
    const newUuid = uuid();
    setInputQuestion("");
  
    // Set the user question
    setMessage((pv) => [
      ...pv,
      {
        human_type: "user",
        content: (
          <>
            {question.trim()}{" "}
          </>
        ),
      },
      {
        bot_id: newUuid,
        human_type: "bot",
        content: (
          <Row>
            <span className="chat-gr-text">Generating response</span>
            <Lottie options={defaultOptions} height={20} width={40} />
          </Row>
        ),
        typingCompleted: null,
      },
    ]);
  
    setIsChatting(true);
  
    const payload = {
      selectType: selectedCardName,
      inputQuestion: question,
    };
  
    try {
      const response = await ChatModelFetch.buzz_reports(payload);
      
      // Assuming response.result contains the final response
      const result = response?.request_id;
  
      setMessage((prevMessages) => {
        const newMessages = [...prevMessages];
        const lastIndex = newMessages.length - 1;
  
        if (lastIndex >= 0 && newMessages[lastIndex]["bot_id"] === newUuid) {
          newMessages[lastIndex] = {
            ...newMessages[lastIndex],
            content: (
              <div>
                Hey, thanks for reaching out with your query. Here is a request ID related to your query: <strong>{result || "No response received from the server."}</strong>.<br />
                You can download the data in sometime through this link: <a href="/buzzreports-download" target="_blank" rel="noopener noreferrer">Download Link</a>
              </div>
            ),
            typingCompleted: true,
            responseID: "1",
            feedbackAccepted: [],
          };
        }
        return newMessages;
      });
  
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching the response.");
    }
  };

  

  const handleClearAll = async () => {
    setIsChatting(false);
    setInputQuestion("");
    setMessage([]);
    setIsTypingStopped(false);
  };


  return (
    <Row className="background-container">
      <TextSqlHeader handleClearAll={handleClearAll} />
      {!isChatting ? (
        <TextSqlHomePage onCardSelect={handleCardSelect} />
      ) : (
        <ChatWindow 
          chat_messages={messages}
          typingStopped={isTypingStopped}
          handleFeedback={handleFeedback}
          handleTypingCompleted={handleTypingCompleted}
        />
      )}

      <Row className="chat-input-section" align="bottom" justify="center">
        <Col>

        {selectedCardMessage && (
            <Text type="secondary" style={{ display: 'block', marginBottom: '8px' }}>
              {selectedCardMessage}
            </Text>
          )}

          <div className="box" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <TextArea
                className="input-chat-box"
                style={{
                  width: '52rem',
                  height: '3.5rem',
                  border: 'none',
                  padding: '10px',
                  borderRadius: '8px',
                  backgroundColor: 'white',
                  color: '#2a2a2a',
                  fontSize: '18px',
                  lineHeight: '23.44px',
                  boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                }}
                placeholder="Ask your question..."
                autoSize={{ minRows: 1, maxRows: 5 }}
                value={inputQuestion}
                onChange={(e) => setInputQuestion(e.target.value)}
                disabled={!selectedCardMessage}
              />
            <Button 
              disabled={!inputQuestion} 
              className="chat-submit-button" 
              onClick={() => handleQuestionSubmitted(inputQuestion)}
            >
              <ArrowRightOutlined />
            </Button>
          </div>

          <Row className="chat-input-lower-div">
            <Text className="chat-input-beta-text">BuzzReports is in Beta version.</Text>
            <Button disabled={!isChatting} type="link" className="chat-input-clear-all" onClick={handleClearAll}>Clear All</Button>
          </Row>
        </Col>
      </Row>
    </Row>
  );

};


export const TextSqlBot = () => {
  return (
    <LoginWrapper>
      <TextSqlBotComponent />
    </LoginWrapper>
  );
};